/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import useMediaQuery from '../hooks/use-media-query';
import FilterHeaderMobile from './filter-header-mobile';

export default function SearchExposedFilters({
  newsSubtypes,
  podcastSubtypes,
  newsConferences,
  specialties,
  opinionSubtypeSubLevel,
  filters,
  setFilters,
  search,
  updateSortModeClass,
}) {
  const [isNewsSubtypeCollapsed, setIsNewsSubtypeCollapsed] = useState(false);
  const [isOptionCollapsed, setIsOptionCollapsed] = useState(false);
  const [isPodcastCollapsed, setIsPodcastCollapsed] = useState(false);
  const [isContentTypeCollapsed, setIsContentTypeCollapsed] = useState(false);
  const [contentTypeLabel, setContentTypeLabel] = useState('');
  const [isSpecialityCollapsed, setIsSpecialityCollapsed] = useState(false);
  const [isSpecialitySubtopicCollapsed, setIsSpecialitySubtopicCollapsed] = useState(false);
  const [specialtyLabel, setSpecialtyLabel] = useState('');
  const [specialtySubtopicLabel, setSpecialtySubtopicLabel] = useState('');
  const [isConferenceCollapsed, setIsConferenceCollapsed] = useState(false);
  const [conferenceLabel, setConferenceLabel] = useState('');
  const [isYearCollapsed, setIsYearCollapsed] = useState(false);
  const [isOverlayOpened, setIsOverlayOpened] = useState(false);
  const [conferenceListSearch, setConferenceListSearch] = useState('');
  const [yearLabel, setYearLabel] = useState('');
  const [isFilterYearSelected, setFilterYearSelected] = useState(false);
  const [isFilterConferenceSelected, setFilterConferenceSelected] = useState(false);
  const [isFilterSpecialtySelected, setFilterSpecialtySelected] = useState(false);
  const [isFilterSpecialtySubtopicSelected, setFilterSpecialtySubtopicSelected] = useState(false);
  const [isFilterContentSelected, setFilterContentSelected] = useState(false);
  const [isMobileOverlaySelected, setMobileOverlaySelected] = useState(false);
  const [searchText, setSearchText] = useState('');
  const isMobile = useMediaQuery('(max-width: 50rem)');
  const [specialtiesSubLevel, setspecialtiesSubLevel] = useState(null);
  const apiSpecialtiesSubLevelURL = new URL(
    `${window.location.origin}/api/v1/content/get_specialties_sub_level`,
  );

  // Hardcoded content type options.
  const contentTypes = [
    { value: 'video', label: 'Videos' },
    { value: 'slide', label: 'Slides' },
    { value: 'news', label: 'News' },
    { value: 'conference', label: 'Conference' },
    { value: 'case_study', label: 'Member Cases' },
    { value: 'audio', label: 'Podcast' },
    { value: 'basic_html', label: 'Partner Content' },
    { value: 'manuscript', label: 'Manuscripts' },
  ];

  useEffect(() => {
    function getSpecialtiesSubLevel(specialty) {
      apiSpecialtiesSubLevelURL.search = new URLSearchParams({
        topic: specialty,
      }).toString();

      fetch(apiSpecialtiesSubLevelURL)
        .then((response) => response.json())
        // eslint-disable-next-line no-shadow
        .then(({ data, success }) => {
          if (success) {
            setspecialtiesSubLevel(data);
          } else {
            setspecialtiesSubLevel(null);
          }
        });
    }

    if (specialtyLabel && specialtyLabel !== 'Specialty') {
      getSpecialtiesSubLevel(specialtyLabel);
    } else {
      setspecialtiesSubLevel(null);
    }

    return function cleanup() {
      setspecialtiesSubLevel(null);
    };
  }, [specialtyLabel]);

  // Get the url parameters from the URL to set the Filter's labels.
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    // Save the url parameters.
    const updatedFilters = {};
    searchParams.forEach((value, key) => {
      updatedFilters[key] = value;
    });

    const keywordFilterLabel = updatedFilters.keyword
      ? updatedFilters.keyword
      : '';

    const contentTypeFilterLabel = updatedFilters.subtype_sub_level
      ? updatedFilters.subtype_sub_level
      : updatedFilters.subtype
        ? updatedFilters.subtype
        : updatedFilters.type
          ? contentTypes.find((item) => item.value === updatedFilters.type).label
          : 'Content Type';

    const specialityFilterLabel = updatedFilters.topic
      ? updatedFilters.topic
      : 'Specialty';

    const specialitySubtopicFilterLabel = updatedFilters.subtopic
      ? updatedFilters.subtopic
      : 'Subtopic';

    const conferenceFilterLabel = updatedFilters.conference === 'any'
      ? 'Any Conference'
      : updatedFilters.conference
        ? updatedFilters.conference.replace('All', '')
        : 'Conference';

    const yearFilterLabel = updatedFilters.year ? updatedFilters.year : 'Year';

    setSearchText(keywordFilterLabel);
    setContentTypeLabel(contentTypeFilterLabel);
    setSpecialtySubtopicLabel(specialitySubtopicFilterLabel);
    setSpecialtyLabel(specialityFilterLabel);
    setConferenceLabel(conferenceFilterLabel);
    setYearLabel(yearFilterLabel);
  }, []);

  // Submit the form by clicking the search button.
  function handleSubmit(event) {
    event.preventDefault();
    const updatedFilters = {
      ...filters,
      page: 1,
    };

    setFilters(updatedFilters);
    search(updatedFilters);
  }

  function closeOverlay() {
    setIsOverlayOpened(false);
    document.body.style.position = null;
  }

  function openOverlay() {
    setIsOverlayOpened(true);
    if (!isMobile) {
      document.body.style.position = 'relative';
    }
  }

  function filterSeleted(content, type) {
    if (type === 'content' && content !== 'Content Type') {
      setFilterContentSelected(true);
    } else if (type === 'specialty' && content !== 'Specialty') {
      setFilterSpecialtySelected(true);
    } else if (type === 'subtopic' && content !== 'Subtopic') {
      setFilterSpecialtySubtopicSelected(true);
    } else if (type === 'year' && content !== 'Conference') {
      setFilterYearSelected(true);
    } else if (type === 'conference' && content !== 'Year') {
      setFilterConferenceSelected(true);
    }
  }

  function reseatSingleFilter(type) {
    const updatedFilters = {
      ...filters,
    };

    if (type === 'year') {
      setFilterYearSelected(false);
      setYearLabel('Year');
      updatedFilters.year = '';
    } else if (type === 'specialty') {
      setFilterSpecialtySelected(false);
      setSpecialtyLabel('Specialty');
      updatedFilters.topic = '';
      updatedFilters.subtopic = '';
    } else if (type === 'subtopic') {
      setFilterSpecialtySubtopicSelected(false);
      setSpecialtySubtopicLabel('Subtopic');
      updatedFilters.subtopic = '';
    } else if (type === 'conference') {
      setFilterConferenceSelected(false);
      setConferenceLabel('Conference');
      updatedFilters.conference = '';
    } else if (type === 'content') {
      setFilterContentSelected(false);
      setContentTypeLabel('Content Type');
      updatedFilters.type = '';
      updatedFilters.subtype = '';
      updatedFilters.subtype_sub_level = '';
    }

    setFilters(updatedFilters);
    search(updatedFilters);
  }

  function handleOverlay(isOpen) {
    if (isOpen) {
      openOverlay();
    } else {
      closeOverlay();
    }
  }

  function handleCollapse(filter = null) {
    let updatedState = null;
    if (filter === 'content-type') {
      updatedState = !isContentTypeCollapsed;
      setIsContentTypeCollapsed(updatedState);
      setIsSpecialityCollapsed(false);
      setIsConferenceCollapsed(false);
      setIsYearCollapsed(false);
      setIsPodcastCollapsed(false);
      setIsSpecialitySubtopicCollapsed(false);
      setIsNewsSubtypeCollapsed(false);
      setIsOptionCollapsed(false);
      handleOverlay(updatedState);
    } else if (filter === 'specialty') {
      updatedState = !isSpecialityCollapsed;
      setIsContentTypeCollapsed(false);
      setIsSpecialityCollapsed(updatedState);
      setIsConferenceCollapsed(false);
      setIsYearCollapsed(false);
      setIsSpecialitySubtopicCollapsed(false);
      handleOverlay(updatedState);
    } else if (filter === 'subtopic-specialty') {
      updatedState = !isSpecialitySubtopicCollapsed;
      setIsContentTypeCollapsed(false);
      setIsSpecialitySubtopicCollapsed(updatedState);
      setIsSpecialityCollapsed(false);
      setIsConferenceCollapsed(false);
      setIsYearCollapsed(false);
      handleOverlay(updatedState);
    } else if (filter === 'conference') {
      updatedState = !isConferenceCollapsed;
      setIsContentTypeCollapsed(false);
      setIsSpecialityCollapsed(false);
      setIsConferenceCollapsed(updatedState);
      setIsYearCollapsed(false);
      setIsSpecialitySubtopicCollapsed(false);
      handleOverlay(updatedState);
    } else if (filter === 'year') {
      updatedState = !isYearCollapsed;
      setIsContentTypeCollapsed(false);
      setIsSpecialityCollapsed(false);
      setIsConferenceCollapsed(false);
      setIsSpecialitySubtopicCollapsed(false);
      setIsYearCollapsed(updatedState);
      handleOverlay(updatedState);
    } else if (filter === 'news') {
      updatedState = !isNewsSubtypeCollapsed;
      setIsNewsSubtypeCollapsed(updatedState);
      setIsPodcastCollapsed(false);
    } else if (filter === 'audio') {
      updatedState = !isPodcastCollapsed;
      setIsNewsSubtypeCollapsed(false);
      setIsPodcastCollapsed(updatedState);
    } else {
      setIsContentTypeCollapsed(false);
      setIsSpecialityCollapsed(false);
      setIsConferenceCollapsed(false);
      setIsYearCollapsed(false);
      setIsSpecialitySubtopicCollapsed(false);
      setIsPodcastCollapsed(false);
      setIsNewsSubtypeCollapsed(false);
      setIsOptionCollapsed(false);
      handleOverlay(false);
    }
  }

  function handleSearchText(event) {
    const seachKeyword = event.target.value;
    setSearchText(seachKeyword);
    setFilters({
      ...filters,
      keyword: seachKeyword,
    });
  }

  function resetSearch() {
    setSearchText('');
    setContentTypeLabel('Content Type');
    setSpecialtyLabel('Specialty');
    setConferenceLabel('Conference');
    setYearLabel('Year');
    setFilterContentSelected(false);
    setFilterSpecialtySelected(false);
    setFilterYearSelected(false);
    setFilterConferenceSelected(false);
    updateSortModeClass('Date');

    const updatedFilters = {
      keyword: '',
      type: '',
      subtype: '',
      subtype_sub_level: '',
      topic: '',
      subtopic: '',
      desc: true,
      page: 1,
      page_size: 12,
      year: '',
      conference: '',
      sortmode: 'Date',
      matching: 'AND',
      searched: true,
    };

    setFilters(updatedFilters);
    search(updatedFilters);
    handleCollapse();
  }

  function handleContentTypeSearch(value, label) {
    filterSeleted(label, 'content');
    setContentTypeLabel(label);
    const updatedFilters = {
      ...filters,
      type: value,
      subtype: '',
      subtype_sub_level: '',
    };

    setFilters(updatedFilters);
    search(updatedFilters);
    handleCollapse('content-type');
  }

  function handleSubtypeSearch(subtype) {
    filterSeleted(subtype, 'content');
    setContentTypeLabel(subtype);
    const updatedFilters = {
      ...filters,
      type: '',
      subtype,
    };

    setFilters(updatedFilters);
    search(updatedFilters);
    handleCollapse();
  }

  function handleSubtypeSubLevelSearch(subTypeSubLevel) {
    filterSeleted(subTypeSubLevel, 'content');
    setContentTypeLabel(subTypeSubLevel);
    const updatedFilters = {
      ...filters,
      type: '',
      subtype: '',
      subtype_sub_level: subTypeSubLevel,
    };

    setFilters(updatedFilters);
    search(updatedFilters);
    handleCollapse();
  }

  function handleSpecialitySearch(specialty) {
    filterSeleted(specialty, 'specialty');
    setSpecialtyLabel(specialty);
    const updatedFilters = {
      ...filters,
      topic: specialty,
      subtopic: '',
    };

    setFilters(updatedFilters);
    search(updatedFilters);
    handleCollapse('specialty');
    // Override the subSpecialty filter.
    setSpecialtySubtopicLabel('Subtopic');
    setFilterSpecialtySubtopicSelected(false);
  }

  function handleSpecialtySubLevelSearch(specialtySubtopic) {
    filterSeleted(specialtySubtopic, 'subtopic');
    setSpecialtySubtopicLabel(specialtySubtopic);
    const specialty = filters.topic;
    const updatedFilters = {
      ...filters,
      topic: specialty,
      subtopic: `${specialty} - ${specialtySubtopic}`,
    };

    setFilters(updatedFilters);
    search(updatedFilters);
    handleCollapse('subtopic-specialty');
  }

  function handleConferenceSearch(conference) {
    const label = conference === 'any' ? 'Any Conference' : conference;
    const filter = conference === 'any' ? 'any' : `All ${conference}`;
    setConferenceLabel(label);
    filterSeleted(conference, 'conference');
    const updatedFilters = {
      ...filters,
      conference: filter,
    };

    setFilters(updatedFilters);
    search(updatedFilters);
    handleCollapse('conference');
  }

  function handleYearSearch(year) {
    filterSeleted(year, 'year');
    setYearLabel(year);
    const updatedFilters = {
      ...filters,
      year: `${year}`,
    };

    setFilters(updatedFilters);
    search(updatedFilters);
    handleCollapse('year');
  }

  function yearsArrayHelper(startYear) {
    const ly = new Date().getFullYear();
    const years = [];

    for (let y = ly; y >= startYear; y -= 1) {
      years.push(y);
    }
    return years;
  }

  function handleConferenceFilterInput(event) {
    setConferenceListSearch(event.target.value);
  }

  function filterConferenceList(conference) {
    return (conference.tag.toUpperCase().indexOf(conferenceListSearch.toUpperCase()) > -1);
  }
  const yearList = yearsArrayHelper(2012);

  const searchMenuMobileOpinion = isOverlayOpened && isMobile ? (
    <div className="search-menu__mobile">
      <button
        className="search-menu__mobile-back"
        type="button"
        onClick={() => {
          setIsOptionCollapsed(false);
        }}
      >
        <h2>Opinion</h2>
      </button>
      <button
        className="search-menu__mobile-close"
        type="button"
        onClick={handleCollapse}
      />
    </div>
  ) : null;

  const renderedOpinionSubtypeSubLevel = opinionSubtypeSubLevel ? (
    <div
      className={`search-list__wrapper ${isOptionCollapsed && !isMobile ? 'collapsed' : ''} ${isOptionCollapsed && isMobile ? 'collapsed-mobile' : ''}`}
    >
      {searchMenuMobileOpinion}
      <ul className="content-subtypes">
        <li className="title">
          <button
            type="button"
            onClick={() => {
              handleSubtypeSearch('Opinion');
              filterSeleted('Opinion', 'opinion');
            }}
          >
            View All Opinion
          </button>
        </li>
        {opinionSubtypeSubLevel.map((item) => (
          <li key={item.subtype_sub_level}>
            <button
              type="button"
              onClick={() => {
                handleSubtypeSubLevelSearch(item.subtype_sub_level);
              }}
            >
              {item.subtype_sub_level}
            </button>
          </li>
        ))}
      </ul>
    </div>
  ) : null;

  const searchMenuMobileNewsSub = isOverlayOpened && isMobile ? (
    <div className="search-menu__mobile">
      <button
        className="search-menu__mobile-back"
        type="button"
        onClick={() => {
          setIsNewsSubtypeCollapsed(false);
        }}
      >
        <h2>News</h2>
      </button>
      <button
        className="search-menu__mobile-close"
        type="button"
        onClick={handleCollapse}
      />
    </div>
  ) : null;

  const searchMenuMobilePodcast = isOverlayOpened && isMobile ? (
    <div className="search-menu__mobile">
      <button
        className="search-menu__mobile-back"
        type="button"
        onClick={() => {
          setIsPodcastCollapsed(false);
        }}
      >
        <h2>Podcast</h2>
      </button>
      <button
        className="search-menu__mobile-close"
        type="button"
        onClick={handleCollapse}
      />
    </div>
  ) : null;

  const renderedNewsSubtype = newsSubtypes && renderedOpinionSubtypeSubLevel ? (
    <div
      className={`search-list__wrapper ${isNewsSubtypeCollapsed && !isMobile ? 'collapsed' : ''} ${isNewsSubtypeCollapsed && isMobile ? 'collapsed-mobile' : ''}`}
    >
      {searchMenuMobileNewsSub}
      <ul className="content-subtypes">
        <li className="title">
          <button
            type="button"
            onClick={() => {
              handleContentTypeSearch('news', 'News');
            }}
          >
            View All News
          </button>
        </li>
        {newsSubtypes.map((item) => {
          if (item.subtype === 'Opinion') {
            return (
              <li className="opinion-container" key={item.subtype}>
                <button
                  type="button"
                  className="item-extended"
                  onClick={() => {
                    setIsOptionCollapsed(!isOptionCollapsed);
                  }}
                >
                  {item.subtype}
                </button>
                {renderedOpinionSubtypeSubLevel}
              </li>
            );
          }
          return (
            <li key={item.subtype}>
              <button
                type="button"
                onClick={() => {
                  handleSubtypeSearch(item.subtype);
                }}
              >
                {item.subtype}
              </button>
            </li>
          );
        })}
      </ul>
    </div>
  ) : null;

  const renderedPodcastSubtype = podcastSubtypes ? (
    <div
      className={`search-list__wrapper ${isPodcastCollapsed && !isMobile ? 'collapsed' : ''} ${isPodcastCollapsed && isMobile ? 'collapsed-mobile' : ''}`}
    >
      {searchMenuMobilePodcast}
      <ul className="content-subtypes">
        <li className="title">
          <button
            type="button"
            onClick={() => {
              handleContentTypeSearch('audio', 'Podcast');
            }}
          >
            View All Podcasts
          </button>
        </li>
        {podcastSubtypes.map((item) => (
          <li key={item.subtype} value={item.subtype}>
            <button
              type="button"
              onClick={() => {
                handleSubtypeSearch(item.subtype);
              }}
            >
              {item.subtype}
            </button>
          </li>
        ))}
      </ul>
    </div>
  ) : null;

  const reseatYearFilter = isFilterYearSelected ? (
    <button
      className="search-filter__reseat"
      type="button"
      onClick={() => {
        reseatSingleFilter('year');
      }}
    />
  ) : null;

  const reseatSpecialtyFilter = isFilterSpecialtySelected ? (
    <button
      className="search-filter__reseat"
      type="button"
      onClick={() => {
        reseatSingleFilter('specialty');
      }}
    />
  ) : null;

  const reseatSpecialtySubtopicFilter = isFilterSpecialtySubtopicSelected ? (
    <button
      className="search-filter__reseat"
      type="button"
      onClick={() => {
        reseatSingleFilter('subtopic');
      }}
    />
  ) : null;

  const reseatConferenceFilter = isFilterConferenceSelected ? (
    <button
      className="search-filter__reseat"
      type="button"
      onClick={() => {
        reseatSingleFilter('conference');
      }}
    />
  ) : null;

  const reseatContentFilter = isFilterContentSelected ? (
    <button
      className="search-filter__reseat"
      type="button"
      onClick={() => {
        reseatSingleFilter('content');
      }}
    />
  ) : null;

  const renderedContentTypeFilter = contentTypes
    && renderedNewsSubtype
    && renderedPodcastSubtype ? (
      <div className="search-exposed-filter__content-type">
        <div className="search-filters-wrapper">
          <button
            type="button"
            className={`search-exposed-filter__label ${isContentTypeCollapsed ? 'dropdown-collapse' : ''} ${isFilterContentSelected ? 'dropdown-collapse-selected' : ''}`}
            onClick={() => {
              handleCollapse('content-type');
            }}
          >
            {contentTypeLabel}
          </button>
          {reseatContentFilter}
        </div>

        <div
          className={`search-list__wrapper ${isContentTypeCollapsed && !isMobile ? 'collapsed' : ''} ${isContentTypeCollapsed && isMobile ? 'collapsed-mobile' : ''}`}
        >
          <FilterHeaderMobile
            isOverlayOpened={isOverlayOpened}
            isMobile={isMobile}
            text="Filter by Content Type"
            handleClose={handleCollapse}
          />
          <ul className="content-type-list">
            {contentTypes.map((item) => {
              if (item.value === 'news') {
                return (
                  <li
                    key={item.value}
                    className={`content-type-item ${
                      isNewsSubtypeCollapsed ? 'extended' : ''
                    }`}
                  >
                    <button
                      type="button"
                      className="item-extended"
                      onClick={() => {
                        handleCollapse('news');
                      }}
                    >
                      {item.label}
                    </button>
                    {renderedNewsSubtype}
                  </li>
                );
              }
              if (item.value === 'audio') {
                return (
                  <li key={item.value} className="content-type-item">
                    <button
                      type="button"
                      className="item-extended"
                      onClick={() => {
                        handleCollapse('audio');
                      }}
                    >
                      {item.label}
                    </button>
                    {renderedPodcastSubtype}
                  </li>
                );
              }
              return (
                <li key={item.value} className="content-type-item">
                  <button
                    type="button"
                    onClick={() => {
                      handleContentTypeSearch(item.value, item.label);
                    }}
                  >
                    {item.label}
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    ) : null;

  const renderedSpecialtyFilter = specialties ? (
    <div className="search-exposed-filter__specialty">
      <div className="search-filters-wrapper">
        <button
          type="button"
          className={`search-exposed-filter__label
            ${isSpecialityCollapsed ? 'dropdown-collapse' : ''}
            ${isFilterSpecialtySelected ? 'dropdown-collapse-selected' : ''}
          `}
          onClick={() => {
            handleCollapse('specialty');
          }}
        >
          {specialtyLabel}
        </button>
        {reseatSpecialtyFilter}
      </div>
      <div
        className={`search-list__wrapper ${isSpecialityCollapsed && !isMobile ? 'collapsed' : ''} ${isSpecialityCollapsed && isMobile ? 'collapsed-mobile' : ''}`}
      >
        <FilterHeaderMobile
          isOverlayOpened={isOverlayOpened}
          isMobile={isMobile}
          text="Filter by Specialty"
          handleClose={handleCollapse}
        />
        <ul className="specialty-list">
          {specialties.map((item) => (
            <li key={item.specialty} className="specialty-item">
              <button
                type="button"
                onClick={() => {
                  handleSpecialitySearch(item.specialty);
                }}
              >
                {item.specialty}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  ) : null;

  const renderedSepecialtySubLevelFilter = specialtiesSubLevel ? (
    <div className="search-exposed-filter__specialty search-exposed-filter__subtopic">
      <div className="search-filters-wrapper">
        <button
          type="button"
          className={`search-exposed-filter__label
            ${isSpecialitySubtopicCollapsed ? 'dropdown-collapse' : ''}
            ${isFilterSpecialtySubtopicSelected ? 'dropdown-collapse-selected' : ''}
          `}
          onClick={() => {
            handleCollapse('subtopic-specialty');
          }}
        >
          {specialtySubtopicLabel}
        </button>
        {reseatSpecialtySubtopicFilter}
      </div>
      <div
        className={`search-list__wrapper ${
          isSpecialitySubtopicCollapsed && !isMobile ? 'collapsed' : ''
        } ${
          isSpecialitySubtopicCollapsed && isMobile ? 'collapsed-mobile' : ''
        }`}
      >
        <FilterHeaderMobile
          isOverlayOpened={isOverlayOpened}
          isMobile={isMobile}
          text="Filter by Subtopic"
          handleClose={handleCollapse}
        />
        <ul className="specialty-list">
          {specialtiesSubLevel.map((item) => (
            <li key={item.name} className="specialty-item">
              <button
                type="button"
                onClick={() => {
                  handleSpecialtySubLevelSearch(item.name);
                }}
              >
                {item.name}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  ) : null;

  const renderedConferenceFilter = newsConferences ? (
    <div className="search-exposed-filter__conference">
      <div className="search-filters-wrapper">
        <button
          type="button"
          className={`search-exposed-filter__label ${
            isConferenceCollapsed ? 'dropdown-collapse' : ''
          } ${isFilterConferenceSelected ? 'dropdown-collapse-selected' : ''}
          `}
          onClick={() => {
            handleCollapse('conference');
          }}
        >
          {conferenceLabel}
        </button>
        {reseatConferenceFilter}
      </div>
      <div
        className={`search-list__wrapper ${isConferenceCollapsed && !isMobile ? 'collapsed' : ''} ${isConferenceCollapsed && isMobile ? 'collapsed-mobile' : ''}`}
      >
        <FilterHeaderMobile
          isOverlayOpened={isOverlayOpened}
          isMobile={isMobile}
          text="Filter by Conference"
          handleClose={handleCollapse}
        />
        <input
          className="conference-type-list__filter"
          placeholder="Search"
          type="text"
          value={conferenceListSearch}
          onChange={handleConferenceFilterInput}
        />
        <ul className="conference-type-list">
          {newsConferences.filter(filterConferenceList).map((item) => (
            <li key={item.tag}>
              <button
                type="button"
                onClick={() => {
                  handleConferenceSearch(item.tag);
                }}
              >
                {item.tag === 'any' ? 'Any Conference' : item.tag}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  ) : null;

  const renderedYearFilter = yearList ? (
    <div className="search-exposed-filter__year">
      <div className="search-filters-wrapper">
        <button
          type="button"
          className={`search-exposed-filter__label
          ${isYearCollapsed ? 'dropdown-collapse' : ''}
          ${isFilterYearSelected ? 'dropdown-collapse-selected' : ''}`}
          onClick={() => {
            handleCollapse('year');
          }}
        >
          {yearLabel}
        </button>
        {reseatYearFilter}
      </div>
      <div
        className={`search-list__wrapper ${isYearCollapsed && !isMobile ? 'collapsed' : ''} ${isYearCollapsed && isMobile ? 'collapsed-mobile' : ''}`}
      >
        <FilterHeaderMobile
          isOverlayOpened={isOverlayOpened}
          isMobile={isMobile}
          text="Filter by Year"
          handleClose={handleCollapse}
        />
        <ul className="year-list">
          {yearList.map((item) => (
            <li key={item}>
              <button
                type="button"
                onClick={() => {
                  handleYearSearch(item);
                }}
              >
                {item}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  ) : null;

  const renderedOverlay =
    isOverlayOpened && !isMobile ? (
      <div
        onClick={handleCollapse}
        className="search-page__modal-div"
        onKeyPress={handleCollapse}
        role="button"
        tabIndex="0"
      />
    ) : null;

  const filterByText = isMobile ? (
    <button
      type="button"
      className={`search-page__filter-dropdown ${isMobileOverlaySelected? 'search-page__filter-dropdown--open': 'search-page__filter-dropdown--close'}`}
      onClick={() => {
        setMobileOverlaySelected(!isMobileOverlaySelected);
      }}
    >
      Filter Results By:
    </button>
  ) : (
    <h3 className="search-page__filter">FILTER BY</h3>
  );

  const renderedFilters = renderedContentTypeFilter
    && renderedSpecialtyFilter
    && renderedConferenceFilter
    && renderedYearFilter ? (
      <div className="search-page__wrapper">
        {filterByText}
        {renderedOverlay}
        <div className={`search-page__filter-container ${isMobileOverlaySelected && isMobile ? 'collapsed' : ''}`}>
          {renderedContentTypeFilter}
          {renderedSpecialtyFilter}
          {renderedSepecialtySubLevelFilter}
          {renderedConferenceFilter}
          {renderedYearFilter}
          <div className="button-clear__container">
            <button
              type="button"
              className="button button-clear"
              onClick={resetSearch}
            >
              Clear all
            </button>
          </div>
        </div>
      </div>
    ) : null;

  const renderedSubmitButton = (
    <button type="submit" className="button-red button-search-page">
      Search
    </button>
  );

  const desktopSubmit = !isMobile ? renderedSubmitButton : null;
  const mobileSubmit = isMobile ? renderedSubmitButton : null;

  return (
    <form onSubmit={handleSubmit}>
      <div className="search-page__keyword">
        <input
          onChange={handleSearchText}
          className="search-filter__search-keyword"
          type="text"
          name="keyword"
          value={searchText}
          placeholder="Enter a Keyword or Phrase…"
        />
        {desktopSubmit}
      </div>
      {renderedFilters}
      {mobileSubmit}
    </form>
  );
}

SearchExposedFilters.propTypes = {
  newsSubtypes: PropTypes.arrayOf(PropTypes.object),
  podcastSubtypes: PropTypes.arrayOf(PropTypes.object),
  newsConferences: PropTypes.arrayOf(PropTypes.object),
  specialties: PropTypes.arrayOf(PropTypes.object),
  opinionSubtypeSubLevel: PropTypes.arrayOf(PropTypes.object),
  filters: PropTypes.shape({
    type: PropTypes.string.isRequired,
    subtype: PropTypes.string,
    subtype_sub_level: PropTypes.string,
    year: PropTypes.string,
    conference: PropTypes.string,
    topic: PropTypes.string,
  }).isRequired,
  setFilters: PropTypes.func.isRequired,
  search: PropTypes.func.isRequired,
  updateSortModeClass: PropTypes.func.isRequired,
};

SearchExposedFilters.defaultProps = {
  newsSubtypes: null,
  podcastSubtypes: null,
  newsConferences: null,
  specialties: null,
  opinionSubtypeSubLevel: null,
};
